export default "__VITE_ASSET__9a87c6de__"